

const { classesRuntime, statesRuntime } = require("./../../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_146_2_border";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_146_2_border__root"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {"radius02":"2px","radius04":"4px","radius06":"6px","radius08":"8px","THEME-RADIUS-02":"var(--wsr-border-radius-02, 2px)","THEME-RADIUS-04":"var(--wsr-border-radius-04, 4px)","THEME-RADIUS-06":"var(--wsr-border-radius-06, 6px)","THEME-RADIUS-08":"var(--wsr-border-radius-08, 8px)"}; 
module.exports.vars = {"wsr-border-radius-02":"--wsr-border-radius-02","wsr-border-radius-04":"--wsr-border-radius-04","wsr-border-radius-06":"--wsr-border-radius-06","wsr-border-radius-08":"--wsr-border-radius-08"}; 




